import { createAction, props } from '@ngrx/store';
import { CommunityItem } from 'src/app/models/community-item';

export const SetCommunityList = createAction(
    '[Community Items] Set Community Items',
    props<{ id: string; list: CommunityItem[] }>()
);

export const AppendCommunityList = createAction(
    '[Community Items] Append Community Items',
    props<{ id: string; list: CommunityItem[] }>()
);

export const RemoveItemFromCommunityLists = createAction(
    '[Community Items] Remove Community Item',
    props<{ id: string }>()
);

export const UpdateItemInCommunityLists = createAction(
    '[Community Items] Update Community Item',
    props<{ item: CommunityItem }>()
);
